export interface IPagination {
  /** The total number of results that can be retrieved. */
  count: number

  /** The URL to use in order to retrieve the next page of results. */
  next: string
}
